import { forwardRef } from 'react';
import { FormField, FormFieldProps } from './form-field';
import { Input } from 'antd';
import { type TextAreaProps } from 'antd/es/input';
import { type TextAreaRef } from 'antd/es/input/TextArea';

const { TextArea } = Input;

type FormTextAreaProps = Omit<FormFieldProps, 'render'> & {
  textareaProps?: TextAreaProps;
};

export const FormTextArea = forwardRef<TextAreaRef, FormTextAreaProps>(
  ({ textareaProps, ...props }, ref) => {
    return (
      <FormField
        {...props}
        render={({ field }) => {
          return <TextArea {...field} {...textareaProps} ref={ref} />;
        }}
      />
    );
  },
);
